import { useQuery } from '@tanstack/react-query';
import { OrderPackage } from '../models';
import QueryKeys from '../utils/QueryKeys';

export default function useOrderPackage(orderPackageId) {
  return useQuery([QueryKeys.ORDER_PACKAGES, orderPackageId], () => (
    OrderPackage
      .includes([
        'cart',
        'background',
        'package',
        'seniorImage',
        { student: 'school' },
        'studentImage',
        { api_option: ['image_types', 'package', 'prices'] },
        { extras: 'prices' },
        { sheets: ['background', { imageType: ['component'] }, 'seniorImage', 'pose', 'foreground'] },
        { addonSheets: ['background', 'seniorImage', { addon: ['component'] }, 'pose', 'foreground'] }])
      .where({ notPurchased: true })
      .find(orderPackageId)
      .then((res) => res.data)
  ), { enabled: !!orderPackageId, staleTime: 0 });
}
